import { Component } from '@angular/core';

@Component({
  selector: 'kp-accordion',
  templateUrl: './accordion.component.html',
  styleUrls: ['./accordion.component.scss'],
})
export class AccordionComponent {}
